<template>
    <div class="device-chart-block">

        <div class="device-chart-title">
            <div v-if="adminTool == false" class="cropperiod-info">{{ cropperiod_name }}</div>
            <div class="device-chart-info">
                <h4 class="header-sub device-name">
                    <i :class="$tools.style.classIcon(device.type, 'block-title')"></i>{{ device.nickname }}
                    <span class="device-hashid">{{ device.hashid }}</span>
                    <span v-if="user_admin" class="block-text device-deviceid">( Device ID = {{ device.deviceid }} )</span>
                </h4>
            </div>


            <div v-if="autoUpdate" class="device-chart-info">

                <!-- 資料說明 -->
                <div v-if="deviceData" class="update-time">
                    <span v-if="deviceData.length > 0">
                        <i class="fa fa-clock-o"></i>{{ $t('menu.observe_time') }}: {{ deviceData[ deviceData.length-1 ].photo_time }} ~ {{ deviceData[ 0 ].photo_time }}
                    </span>

                    <!-- 自動更新頻率 -->
                    <!-- <div v-if="user_admin || $tools.service.check_ShowUI_byRole(this.project_role, 'update_frequency')" class="admin-info">
                        <i class="fa fa-gift block-text"></i>
                        {{ $t('menu.update_frequency') }}： {{ $t('menu.per') }} {{ autoUpdateMinutes }} {{ $t('u.minutes') }}
                    </div> -->

                </div>
            </div>
            <div v-else class="device-chart-info">
                <!-- 資料說明 -->
                <div v-if="deviceData" class="update-time">

                    <!-- Admin -->
                    <div v-if="user_admin || $tools.service.check_ShowUI_byRole(this.project_role, 'data_count')" class="admin-info">

                        <!-- 觀測時間 -->
                        <div v-if="deviceData.length > 0" class="block-text">
                            <i class="fa fa-clock-o"></i>{{ $t('menu.observe_time') }}: {{ deviceData[ deviceData.length-1 ].photo_time }} ~ {{ deviceData[ 0 ].photo_time }}
                        </div>

                        <!-- 資料筆數 -->
                        <div class="block-text">
                            <i class="icon-lock icons"></i>{{ $t('menu.data_count') }}：{{ deviceData.length }} / {{ importQuery_DataCount }}
                            ( {{ importQuery_Range }} {{ $t('u.pictures') }} )
                        </div>

                    </div>
                </div>
            </div>

            <!-- 阿龜資料讀取畫面 -->
            <div v-if="loading_showInfo" class="device-chart-info">
                <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
            </div>

        </div>
        <div v-if=" autoUpdate == false && device.description " class="device-chart-info device-chart-description">{{ device.description }}</div>

        <div v-if="deviceData && deviceData.length > 0">
            <b-row>
                <!-- 電量 & 訊號線圖 -->
                <!-- <b-col cols="12" md="12" v-if="chartData.time && chartData.time.length > 0">

                    <b-row class="device-chart-list">
                        <b-col v-if="chartData.voltage_to_battery_percentage" class="device-chart-col" cols="12" sm="6" md="5" xl="4" >

                            <Callout variant="warning">
                                <small class="text-muted">{{ $t('sensor.voltage_to_battery_percentage') }}</small><br>
                                <h4 class="block-text">
                                    <strong>
                                        {{ chartData[ 'voltage_to_battery_percentage' ][ chartData.time.length - 1 ] }} {{ $t('sensor.u_voltage_to_battery_percentage') }}
                                    </strong>
                                </h4>
                                <br>
                                <code>{{ chartData.time[0] }} ==> {{ chartData.time[ chartData.time.length - 1 ] }}</code>
                                <div class="chart-wrapper" :style="{ top: '0px', 'margin-left': '-50px', 'width': '150px', }">
                                    <vueChartCalloutChart chartId="callout-chart-01"
                                        :data="chartData[ 'voltage_to_battery_percentage' ]"
                                        :data_unit="$t('sensor.u_voltage_to_battery_percentage')"
                                        :x_axis="chartData.time"
                                        :y_axis_max="100" :y_axis_min="0"
                                        :variant="'#ff9933'" width="100" height="30" />
                                </div>
                            </Callout>
                        </b-col>
                        <b-col v-if="chartData.signal" class="device-chart-col" cols="12" sm="6" md="5" xl="4" >
                            <Callout variant="info">
                                <small class="text-muted">{{ $t('sensor.rssi') }}</small><br>
                                <h4 class="block-text">
                                    <strong>
                                        {{ chartData[ 'signal' ][ chartData.time.length - 1 ] }} %
                                    </strong>
                                </h4>
                                <br>
                                <code class="text-success">{{ chartData.time[0] }} ==> {{ chartData.time[ chartData.time.length - 1 ] }}</code>
                                <div class="chart-wrapper" :style="{ top: '0px', 'margin-left': '-50px', 'width': '150px', }">
                                    <vueChartCalloutChart chartId="callout-chart-01"
                                        :data="chartData[ 'signal' ]"
                                        :data_unit="'%'"
                                        :x_axis="chartData.time"
                                        :y_axis_max="100" :y_axis_min="0"
                                        :variant="'#33e7ff'" width="100" height="30" />
                                </div>
                            </Callout>
                        </b-col>
                    </b-row>

                </b-col> -->

                <b-col cols="12" md="12">
                    <div class="area-overflow-x grab-bing scroll-style" v-dragscroll v-on:dragscrollmove="dragMoving($event.detail.deltaX)">

                        <b-card class="card camera-photo-block" no-body v-for="(photo, idx_p) in deviceData" :key="idx_p">
                            <b-card-img class="camera-photo-img clickable-img"
                                        :src="$config.checkURL('photo',photo.file_path)" :img-alt="'Image'" top
                                        @click="showPreview(idx_p)"></b-card-img>
                            <div>
                                <div class="camera-photo-date">{{ photo.photo_time }}</div>
                            </div>
                            <div class="camera-photo-note scroll-style" v-dragscroll.y="true">
                                <!-- 描述 -->
                                <div class="child">{{ photo.note }}</div>
                            </div>

                        </b-card>
                    </div>

                    <vue-gallery-slideshow :images="getAllImages" :index="previewIndex" @close="previewIndex = null"></vue-gallery-slideshow>

                </b-col>

            </b-row>
        </div>
        <div v-else>
            <NoData></NoData>
        </div>

    </div>
</template>


<script>
import { mapState } from 'vuex'
import AgriLoading  from '@/views/components/AgriLoading'
import NoData       from '@/views/components/NoData'
import LineChart    from '@/views/echarts/LineChart'
import { Callout }  from '@coreui/vue'
import vueChartCalloutChart from '@/views/echarts/vueChart_CalloutChart'

import VueGallerySlideshow from 'vue-gallery-slideshow' // 點圖放大、左右切換撥放工具
import { dragscroll } from 'vue-dragscroll'             // 滑鼠可拖拉 scroll 區域

export default {
    props: {
        adminTool: {
            type: Boolean,
            required: false,
        },
        device: {
            type: Object,
            required: true,
        },
        timezone: {
            type: String,
            required: true,
        },
        cropperiod_uuid: {
            type: [String, Number],
            required: true,
        },
        cropperiod_name: {
            type: String,
        },
        importData: {
            type: Array,
        },
        importQuery_Range: {
            type: Number,
            default: 0,
        },
        importQuery_DataCount: {
            type: Number,
            default: 0,
        },
        autoUpdate: {
            type: Boolean,
            default: true,
        },
    },
    components: {
        AgriLoading,
        NoData,
        LineChart,
        Callout,
        vueChartCalloutChart,
        VueGallerySlideshow,
    },
    directives: {
        'dragscroll': dragscroll,
    },
    data () {
        return {
            mouse_drag: false,
            previewIndex: null,     // gallery view
            deviceData: undefined,
            queryRange: 6,
            timer: '',
            autoUpdateMinutes: 1 * 60, // 一小時更新一次
            loading_showInfo: false,

            uploading: false,
            is_editable: false,
            editNoteModal: false,
            edit_photo: undefined,
            edit_text: '',

            chartData: {
                time: undefined,
                voltage: undefined,
            },
        }
    },
    created ()
    {
        if (this.autoUpdate)
        {
            let _intervalTime = this.autoUpdateMinutes * 60 * 1000;
            this.timer = setInterval(this.updateDeviceData, _intervalTime);
        }
    },
    mounted ()
    {
        if (this.importData)
        {
            this.deviceData = this.importData
        }
        else
        {
            this.updateDeviceData()
        }
    },
    computed: {
        ...mapState({
            'user_admin': state => state.user.is_admin,
        }),

        getAllImages ()
        {
            let _photoList = [];

            this.deviceData.forEach( _photo => {
                _photoList.push( this.$config.checkURL('photo', _photo.file_path) );
            })

            return _photoList;
        },
    },
    watch: {

        importData ()
        {
            this.deviceData = this.importData
        },

        deviceData ()
        {
            this.arrangeChartData()
        },

    },
    methods: {

        arrangeChartData ()
        {
            let _time = []
            let _voltage = [], _draw_voltage = false, _voltage_to_battery_percentage = []
            let _signal = [], _draw_signal = false

            if ( this.deviceData && this.deviceData.length > 0 )
            {
                this.deviceData.forEach( _data => {
                    _time.push( _data.photo_time )

                    _voltage.push( _data.voltage )
                    if ( _data.voltage != undefined ) _draw_voltage = true

                    _signal.push( _data.signal_quality )
                    if ( _data.signal_quality != undefined ) _draw_signal = true
                })
            }

            if ( _draw_voltage == true )
            {
                _voltage_to_battery_percentage = this.$tools.ui.getVoltageToPercentage(_voltage)
            }

            this.chartData = {
                time:                           _time.reverse(),
                voltage:                        ( _draw_voltage ? _voltage.reverse() : undefined ),
                voltage_to_battery_percentage:  ( _draw_voltage ? _voltage_to_battery_percentage.reverse() : undefined ),
                signal:                         ( _draw_signal ? _signal.reverse() : undefined ),
            }
        },

        // 偵測到在 scroll 區域用滑鼠拖動中
        dragMoving (deltaX)
        {
            this.mouse_drag = true;
            // console.log('drag');
        },
        // 判斷非拖動狀態下，指定相簿顯示
        showPreview (index)
        {
            if (this.mouse_drag == false)
            {
                this.previewIndex = index;
                // console.log('click');
            }
            this.mouse_drag = false;
        },

        setQueryRange (range)
        {
            this.queryRange = range;
            this.updateDeviceData();
        },
        activeQueryRage (range)
        {
            if (this.queryRange == range) return true
            return false
        },

        updateDeviceData ()
        {
            this.loading_showInfo = true

            const options = {
                method: 'GET',
                url: this.$config.getAPI_URL('Cropperiod_Public_Camera_Realtime', { cropperiodUUID: this.cropperiod_uuid, deviceID: this.device.hashid }),
            }
            this.$http(options)
            .then( res => {
                this.loading_showInfo = false

                let _deviceData = res.data[ this.device.hashid ];
                _deviceData.forEach( _device => {
                    _device.photo_time = this.$tools.date.dateTimeZone( _device.photo_time, this.timezone, 'YYYY-MM-DD HH:mm' )
                })

                this.deviceData = _deviceData;
            })
            .catch( err => {
                this.loading_showInfo = false
            })
        },

    },
    beforeDestroy ()
    {
        // Cancel Auto Update
        if (this.autoUpdate)
        {
            clearInterval(this.timer)
        }
    }
}
</script>


<style lang="scss" scoped>

.device-hashid
{
  font-size: 0.8rem;
  margin-left: 8px;
}
.device-deviceid {
    font-size: 0.75rem;
    margin-left: 5px;
}
.device-chart-block
{
    margin-top: 5px;
    margin-bottom: 20px;
    padding: 10px 0px;
}
.device-chart-title
{
    margin-bottom: 5px;
    .device-name
    {
        display: inline-block;
        margin-right: 20px;
        i {
            color: #cea212;
        }
    }
    .cropperiod-info
    {
        //display: inline-block;
        margin-left: 25px;
        margin-bottom: -10px;
        margin-right: 20px;
        color: #747974;
    }
    .update-time
    {
        display: inline-block;
        margin-right: 20px;
        color: #368a3b;
        i {
            color: #9ec7a1;
        }
    }
    .admin-info
    {
        display: inline-block;
        margin-left: 20px;
        margin-right: 20px;
        color: #e14b4b;
        i {
            color: #c97676;
        }
    }
    .query-range
    {
        display: inline-block;
        margin-right: 20px;
        color: #368a3b;

        button
        {
            padding: 3px 10px;
            &:hover
            {
                color: #c4f386;
            }
        }
    }
}
.device-chart-info
{
    display: inline-block;
    margin-right: 15px;
}

</style>
